// Builds the outgoing share text from an admin-editable template.
// {link} is replaced with the client's resource-list URL; appended if omitted.
export const buildShareMessage = (template, link, signature) => {
  const tpl = (template || '').trim();
  let body = tpl.includes('{link}') ? tpl.replace(/\{link\}/g, link) : `${tpl} ${link}`.trim();
  const sig = (signature || '').trim();
  if (sig) body = `${body}\n\n${sig}`;
  return body;
};
